import classNames from 'classnames'
import React from 'react'

import {trueRound} from 'app/utils/numbers'

import * as styles from './styles.less'

export default function HealthScoreSvg({score, className, ...restProps}) {
  let scoreString, signClassName
  if (score === null) {
    scoreString = '--'
    signClassName = styles.neutral
  } else {
    const intScore = trueRound(score)
    let sign = ''
    if (intScore > 0) {
      signClassName = styles.positive
      sign = '+'
    } else if (intScore < 0) {
      signClassName = styles.negative
    } else {
      signClassName = styles.neutral
    }
    scoreString = `${sign}${intScore}`
  }
  return (
    <text
      className={classNames(styles.healthScore, signClassName, className)}
      {...restProps}
    >
      {scoreString}
    </text>
  )
}
